import React, { useEffect, useState } from 'react'
import { trackPromise } from 'react-promise-tracker'

import { GetIncomeAssetChart } from 'store/ChartApiClient'
import GraphSummaryText from '../../components/GraphSummaryText'
import { StyleSeries } from 'highcharts/HighchartsStyleHelper'
import { SetupDefaultOptions, FULL_HEIGHT_NO_INPUT_ROW } from 'highcharts/HighchartsHelper'
import LoadingWrapper from 'components/LoadingWrapper'
import HighchartsWrapper from '../../../../../../highcharts/HighchartsWrapper'

const IncomeAssetStep = ({ id }) => {
    const PromiseArea = 'graph-income'
    const [options, setOptions] = useState({})
    const [error, setError] = useState(null)

    useEffect(() => {
        const StyleGraph = (opts) => {
            opts = SetupDefaultOptions(opts, FULL_HEIGHT_NO_INPUT_ROW, false)

            if (opts.series) {
                opts.series = opts.series.map((p) => StyleSeries(p))
            }

            setOptions(opts)
        }

        trackPromise(
            GetIncomeAssetChart(id)
                .then((resp) => {
                    const { data } = resp
                    StyleGraph(data)
                })
                .catch((err) => {
                    setError(err)
                })
                .finally(() => {}),
            PromiseArea
        )
    }, [id])

    if (error) {
        return <p>Something went wrong, try again later</p>
    }

    return (
        <LoadingWrapper area={PromiseArea}>
            <GraphSummaryText options={options} />
            <HighchartsWrapper options={options} printHeightPx={450} />
        </LoadingWrapper>
    )
}

export default IncomeAssetStep
